import { render } from "./HelpText.vue?vue&type=template&id=541a81e0"
import script from "./HelpText.vue?vue&type=script&lang=js"
export * from "./HelpText.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HelpText.vue"]])

export default __exports__